<template lang="pug">
#monitoramento-operacao
    BaseHeader(
        :titulo='$t("mensagens.operacao.monitoramento.visualizarMonitoramento")',
        :voltarPara='true'
    )

    .view-container-base-header
        section.monitoramento-operacao__dados-gerais(v-if='dadosMonitoramento')
            .titulo_padrao
                | {{ $t('mensagens.operacao.monitoramento.dadosGeraisOperacaoMonitorada') }}

            .monitoramento-operacao__dados-gerais__body
                .row.mb-5
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | {{ $t('mensagens.operacao.tabela.nome') }}
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.nome ? dadosMonitoramento.nome : '--' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | {{ $t('mensagens.operacao.tabela.categoria') }}
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.nomeCategoria }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | {{ $t('mensagens.operacao.tabela.numContrato') }}
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.numeroContrato ? dadosMonitoramento.numeroContrato : '--' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | {{ $t('mensagens.operacao.formularioGeral.identificadorOperacao') }}
                        .monitoramento-operacao__dados-gerais__body__value(
                            style='word-break: break-all'
                        )
                            | {{ dadosMonitoramento.identificadorOperacao }}
                .row
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | {{ $t('mensagens.operacao.formularioGeral.dataContratacao') }}
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.dataContratacao }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | {{ $t('mensagens.operacao.formularioGeral.dataLiberacao') }}
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.dataLiberacao }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | {{ $t('mensagens.operacao.tabela.vigencia') }}
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.dataVigencia }}
                    .col-3.data-display
                        .monitoramento-operacao__dados-gerais__body__title
                            | {{ $t('mensagens.operacao.formularioGeral.valorTotalOperacao') }}
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ formatarValorTotalOperacao(dadosMonitoramento.valorTotalOperacao) }}

                .row(v-if='dadosMonitoramento.possuiPrimeiraAnalise === true')
                    .col-12
                        div
                            hr
                            .monitoramento-operacao__dados-gerais__body__title
                                | {{ $t('mensagens.operacao.monitoramento.revisarAnaliseTexto1') }}&nbsp;
                                BaseButton.button-link(
                                    type='text',
                                    @click='downloadPrimeiraAnalise()'
                                ) {{ $t('mensagens.operacao.monitoramento.revisarAnaliseTexto2') }}

                .row(
                    v-if='dadosMonitoramento.mostrarElegibilidadeBonusCar === true'
                )
                    .col-12.data-display
                        .operacao__card__elegibilidade-bonus-car.row(
                            :style='"background:" + operacaoBonusCar[dadosMonitoramento.elegivelBonusCar].cor'
                        )
                            .col-1.p-0(style='height: 100%')
                                .operacao__card__elegibilidade-bonus-car--icone(
                                    :style='"background:" + operacaoBonusCar[dadosMonitoramento.elegivelBonusCar].corFundoIcone'
                                )
                                    .d-flex.justify-content-center.align-items-center
                                        .operacao__card__elegibilidade-bonus-car--icone--background
                                        i(
                                            :class='operacaoBonusCar[dadosMonitoramento.elegivelBonusCar].icone',
                                            :style='"color:" + operacaoBonusCar[dadosMonitoramento.elegivelBonusCar].corIcone'
                                        )
                            .col-11.text-justify
                                div {{ operacaoBonusCar[dadosMonitoramento.elegivelBonusCar].titulo }}

        section.monitoramento-operacao__atividades
            .titulo_padrao
                | {{ $t('mensagens.operacao.atividades') }}

            .tabela(style='height: 210px; width: 100%')
                el-table(:data='atividades', height='calc(100% - 54px)')
                    el-table-column(
                        :label='$t("mensagens.operacao.formularioAtividade.tipo")'
                    )
                        template(slot-scope='scope')
                            span
                                | {{ scope.row.tipo === 'agrícola' ? $t('mensagens.operacao.formularioAtividade.agricola') : $t('mensagens.operacao.formularioAtividade.pecuaria') }}
                    el-table-column(
                        :label='$t("mensagens.operacao.formularioAtividade.produto")'
                    )
                        template(slot-scope='scope')
                            span(style='word-break: keep-all')
                                | {{ scope.row.nomeProduto }}
                    el-table-column(
                        :label='$t("mensagens.operacao.formularioAtividade.areaFinanciadaHa")'
                    )
                        template(slot-scope='scope')
                            money.remove-estilos(
                                v-model='scope.row.areaFinanciada',
                                v-bind='areaMask',
                                readonly
                            )
                    el-table-column(
                        :label='$t("mensagens.operacao.formularioAtividade.quantidade")'
                    )
                        template(slot-scope='scope')
                            span
                                | {{ scope.row.tipo === 'pecuária' ? scope.row.quantidade : '--' }}
                    el-table-column(
                        :label='$t("mensagens.operacao.formularioAtividade.inicioPlantio")'
                    )
                        template(slot-scope='scope')
                            span
                                | {{ scope.row.tipo === 'agrícola' ? scope.row.inicioPlantioFormatado : '--' }}
                    el-table-column(
                        :label='$t("mensagens.operacao.formularioAtividade.fimPlantio")'
                    )
                        template(slot-scope='scope')
                            span
                                | {{ scope.row.tipo === 'agrícola' ? scope.row.fimPlantioFormatado : '--' }}
                    el-table-column(
                        :label='$t("mensagens.operacao.formularioAtividade.inicioColheita")'
                    )
                        template(slot-scope='scope')
                            span
                                | {{ scope.row.tipo === 'agrícola' ? scope.row.inicioColheitaFormatado : '--' }}
                    el-table-column(
                        :label='$t("mensagens.operacao.formularioAtividade.fimColheita")'
                    )
                        template(slot-scope='scope')
                            span
                                | {{ scope.row.tipo === 'agrícola' ? scope.row.fimColheitaFormatado : '--' }}

                .tabela-rodape
                    .tabela-rodape--esquerda
                        p {{ atividades.length }} {{ $t('mensagens.operacao.formularioAtividade.atividadesNaOperacao') }}

        section.monitoramento-operacao__restricoes
            .monitoramento-operacao__restricoes__icone
                i.mdi.mdi-bell.monitoramento-operacao__restricoes__icone__icone

            .monitoramento-operacao__restricoes__texto
                | {{ totalRestricoes }} {{ $t('mensagens.operacao.monitoramento.textoTotalRestricoes') }}

        section.monitoramento-operacao__listagem-territorios
            .titulo_padrao
                | {{ $t('mensagens.operacao.monitoramento.listagemMonitorados') }}

            .row.m-0
                .col-7.px-0.tabela
                    el-table(
                        :data='territorios',
                        stripe,
                        height='calc(100% - 54px)'
                    )
                        el-table-column(type='expand')
                            template(slot-scope='props')
                                .box-expande-listagem
                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | {{ $t('mensagens.operacao.formularioGleba.areaHa') }}
                                        .box-expande-listagem-box-value
                                            div {{ props.row.areaHa }}

                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | {{ $t('mensagens.operacao.monitoramento.pessoaDocumento') }}
                                        .box-expande-listagem-box-value.lista-scroll(
                                            v-if='props.row.representantes !== null && props.row.representantes.length > 0'
                                        )
                                            div(
                                                v-for='(cpfCnpj, index) in props.row.representantes',
                                                :key='index'
                                            )
                                                div {{ cpfCnpj }}
                                        .pl-1(v-else) --

                        el-table-column(
                            :label='$t("mensagens.operacao.formularioGleba.territorio")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.nome }}

                        el-table-column(
                            :label='$t("mensagens.operacao.carVinculado")'
                        )
                            template(slot-scope='scope')
                                .car(v-if='scope.row.cars && scope.row.cars.length == 1')
                                    span {{ scope.row.cars[0] }}
                                .car(v-else-if='scope.row.cars && scope.row.cars.length > 1')
                                    p.car-hiden-row {{ scope.row.cars[0] }}
                                    el-popover(
                                        placement='bottom',
                                        trigger='hover'
                                    )
                                        el-tag.ml-2(size='mini', slot='reference') {{ scope.row.cars.length }}
                                        .lista-scroll
                                            div(
                                                v-for='(car, index) in scope.row.cars',
                                                :key='index'
                                            ) {{ car }}
                                .car(v-else)
                                    p -

                        el-table-column(
                            :label='$t("mensagens.blocoFiltros.uteis.municipio")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.localidade }}

                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.restricoes")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.restricao }}

                        el-table-column(
                            :label='$t("mensagens.operacao.titulo")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.operacoes }}
                                el-tooltip(effect='dark', placement='top')
                                    template(slot='content')
                                        div(
                                            v-for='(operacao, index) in scope.row.operacoesRelacionadas',
                                            :key='index'
                                        )
                                            span {{ $t('mensagens.operacao.monitoramento.id') + ': ' + operacao.identificador + ' | ' + $t('mensagens.operacao.tabela.nome') + ': ' + operacao.nome }}

                                    i.mdi.mdi-information-outline.ml-1

                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.acoes")',
                            width='100',
                            align='center'
                        )
                            template(slot-scope='scope')
                                el-dropdown.action-button(trigger='click')
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical.mudando-cursor
                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            v-for='(acao, index) in acoesTerritorio',
                                            :key='index',
                                            :icon='acao.icone',
                                            @click.native='acao.callback(scope.row)'
                                        ) {{ $t(`mensagens.operacao.monitoramento.${acao.nome}`) }}

                    .tabela-rodape
                        .tabela-rodape--esquerda
                            p {{ territorios.length }} {{ $t('mensagens.operacao.monitoramento.territoriosMonitoramento') }}

                .col-5.pr-0
                    .mapaMonitoramentoOperacao
                        mapa(
                            :showStatesLayers='false',
                            :mapLayersConfigs='layersMaps',
                            :mapConfig='mapConfig',
                            :height='"100%"',
                            :idMapa='"mapaMonitoramentoOperacao"',
                            ref='mapa',
                            :doubleMapOnPage='false'
                        )

        section.monitoramento-operacao__listagem-pessoas
            .titulo_padrao
                | {{ $t('mensagens.operacao.monitoramento.listagemPessoasMonitoradas') }}

            .row.m-0
                .col-12.px-0.tabela
                    el-table(
                        :data='pessoas',
                        stripe,
                        height='calc(100% - 54px)'
                    )
                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.nomeRazaoSocial")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.nomeRazaoSocial }}

                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.documento")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.cpfCnpj }}

                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.papelPessoa")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.papel }}

                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.restricoes")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.restricoes }}

                        el-table-column(
                            :label='$t("mensagens.operacao.titulo")'
                        )
                            template(slot-scope='scope')
                                span {{ scope.row.operacoes }}
                                el-tooltip(effect='dark', placement='top')
                                    template(slot='content')
                                        div(
                                            v-for='(operacao, index) in scope.row.operacoesRelacionadas',
                                            :key='index'
                                        )
                                            span {{ $t('mensagens.operacao.monitoramento.id') + ': ' + operacao.identificador + ' | ' + $t('mensagens.operacao.tabela.nome') + ': ' + operacao.nome }}

                                    i.mdi.mdi-information-outline.ml-1

                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.acoes")',
                            width='100',
                            align='center'
                        )
                            template(slot-scope='scope')
                                el-dropdown.action-button(trigger='click')
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical.mudando-cursor
                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            v-for='(acao, index) in acoesPessoas',
                                            :key='index',
                                            :icon='acao.icone',
                                            @click.native='acao.callback(scope.row)'
                                        ) {{ $t(`mensagens.operacao.monitoramento.${acao.nome}`) }}

                    .tabela-rodape
                        .tabela-rodape--esquerda
                            p {{ pessoas.length }} {{ $t('mensagens.operacao.monitoramento.pessoasMonitoramento') }}

    ModalResultadoDiagnostico(
        ref='modalResultadoDiagnosticoRef',
        habilitar-inibicao-camada,
        @atualizarDadosMonitoramento='buscarDadosMonitoramentoOperacao'
    )
</template>

<script>
import ModalResultadoDiagnostico from '@/components/operacao/gestao/ModalResultadoDiagnostico.vue';
import OperacaoMonitoramentoService from '@/services/OperacaoMonitoramentoService';
import OperacaoService from '@/services/OperacaoService';
import Mapa from '@/components/MapaLeaflet';
import BaseHeader from '@/components/BaseHeader.vue';
import { Money } from 'v-money';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import formatters from '@/utils/formatters';
import { calcularBuffer } from '@/utils/calcularBuffer.js';

export default {
    name: 'index',
    components: {
        BaseHeader,
        ModalResultadoDiagnostico,
        Mapa,
        Money,
        BaseButton
    },
    data() {
        return {
            atividades: [],
            areaMask: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            acoesTerritorio: [
                {
                    nome: 'VISUALIZAR_ANALISE_TERRITORIO',
                    icone: 'flow flow-environment',
                    callback: this.visualizarAnaliseTerritorio
                }
            ],
            acoesPessoas: [
                {
                    nome: 'VISUALIZAR_ANALISE_PESSOA',
                    icone: 'flow flow-environment',
                    callback: this.visualizarAnalisePessoa
                }
            ],
            operacaoBonusCar: {
                true: {
                    cor: 'var(--approved-operation)',
                    corIcone: 'var(--secondary-two)',
                    corFundoIcone: 'var(--secondary)',
                    icone: 'mdi mdi-checkbox-marked-circle',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.elegivelBonusCar'
                    )
                },

                false: {
                    cor: 'var(--disapproved-operation)',
                    corIcone: 'var(--font-danger)',
                    corFundoIcone: '#DF675B',
                    icone: 'mdi mdi-close-circle',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.naoElegivelBonusCar'
                    )
                }
            },
            dadosMonitoramento: null,
            diagnosticosProtocolo: [],
            territorios: [],
            totalRestricoes: this.$t('mensagens.comuns.semDados'),
            pessoas: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    popupControl: false,
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: false,
                    fullscreen: false,
                    buscarCarControl: false,
                    bufferControl: false,
                    uploadFileControl: false,
                    camadasBaseControl: false,
                    botaoAnotacoes: false,
                    ferramentasControl: false
                },
                inspecionar: false,
                diagnostico: false
            }
        };
    },

    async mounted() {
        await this.buscarDadosMonitoramentoOperacao();
    },

    methods: {
        adicionarPontosMapaTerritorio() {
            this.territorios.forEach(territorio => {
                this.layersMaps.push({
                    name: 'areaMonitorada_' + territorio.id,
                    geoJson: territorio.centroide,
                    style: {
                        radius: 4,
                        fill: true,
                        fillColor: '#27d14c',
                        color: '#27d14c',
                        weight: 10,
                        opacity: 0.3,
                        fillOpacity: 1.0
                    }
                });
            });
        },

        async buscarDadosMonitoramentoOperacao() {
            await OperacaoMonitoramentoService.buscarDadosMonitoramento(
                this.$route.params.id
            )
                .then(({ data }) => {
                    this.dadosMonitoramento = data;
                    this.territorios = data.territorios;
                    this.pessoas = data.pessoas;
                    if (data.totalRestricoes) {
                        const numeroTotal = data.totalRestricoes
                            .split('restrições encontradas no monitoramento')[0]
                            .trim();
                        this.totalRestricoes = numeroTotal;
                    }
                    this.atividades = data.atividades;

                    this.adicionarPontosMapaTerritorio();
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.operacao.notificacao.erroDadosMonitoramentoOperacao'
                        )
                    });
                    this.$router.push({ name: 'operacao' });
                });
        },

        agruparPorCamada(itens, defaultCodigo = 'AREA_ANALISADA', geometriaTerritorio) {
            const agrupado = {};

            itens.forEach(item => {
                let geometriaProximidade = null;
                let geometriaDoCar = null;
                let geometriaAnterior = null;
                
                if (defaultCodigo === 'PROXIMIDADE_TERRITORIO_ANALISADO') {
                    const bufferGeometria = calcularBuffer(geometriaTerritorio, item.propriedades?.bufferMetros);
                    geometriaProximidade = bufferGeometria;
                }

                if (!agrupado[item.codigoCamada]) {
                    if (item.codigoCamada === 'GLEBA_DESLOCADA' && geometriaAnterior === null) {
                        geometriaAnterior = item.propriedades?.geometriaAnterior;
                    }
                    agrupado[item.codigoCamada] = {
                        camada: {
                            codigo: item.codigoCamada,
                            nome: item.propriedades?.camada?.nome,
                            fonte: item.propriedades?.camada?.fonte || {}
                        },
                        resultados: [],
                        nivelAlerta: item.nivelAlerta || 'BAIXO',
                        codigo: defaultCodigo,
                        bufferMetros: item.propriedades?.bufferMetros,
                        geometriaProximidade: geometriaProximidade,
                        geometriaDoCar: geometriaDoCar,
                        geometriaAnterior: geometriaAnterior
                    };
                }

                agrupado[item.codigoCamada].resultados.push({
                    id: item.codigoRestricao,
                    type: 'Feature',
                    propriedade: null,
                    properties: item.propriedades,
                    geometry: item.geometria,
                    geometria: null,
                    inibido: item.inibido,
                    inibidoAutomaticamente: item.inibidoAutomaticamente,
                    dataInibido: item.dataInibido
                });
            });

            return Object.values(agrupado);
        },

        agruparPorTipo(itens, identificadorKey) {
            if (itens.length === 0) {
                return [[], []];
            }

            const resultadoFinal = [];

            itens.forEach(item => {
                if (!item.restricoes || item.restricoes.length === 0) {
                    resultadoFinal.push([]);
                    return;
                }

                const agrupado = {};

                item.restricoes.forEach(restricao => {
                    let geometriaProximidade, geometriaDoCar;

                    if (identificadorKey === 'PROXIMIDADE_CAR_ANALISADO') {
                        geometriaDoCar = JSON.parse(restricao.propriedades?.informacoesGerais?.geometria);
                        const bufferGeometria = calcularBuffer(geometriaDoCar, restricao.propriedades?.bufferMetros);
                        geometriaProximidade = bufferGeometria;
                    }

                    if (!agrupado[restricao.codigoCamada]) {
                        agrupado[restricao.codigoCamada] = {
                            camada: {
                                codigo: restricao.codigoCamada,
                                nome: restricao.propriedades?.camada?.nome,
                                fonte: restricao.propriedades?.camada?.fonte || {}
                            },
                            resultados: [],
                            nivelAlerta: restricao.nivelAlerta || 'BAIXO',
                            codigo: identificadorKey,
                            bufferMetros: restricao.propriedades?.bufferMetros,
                            geometriaProximidade: geometriaProximidade,
                            geometriaDoCar: geometriaDoCar,
                            nomePessoa: item.nomePessoa
                        };
                    }

                    agrupado[restricao.codigoCamada].resultados.push({
                        id: restricao.codigoRestricao,
                        type: 'Feature',
                        propriedade: null,
                        properties: restricao.propriedades,
                        geometry: restricao.geometria,
                        geometria: null,
                        inibido: restricao.inibido,
                        inibidoAutomaticamente: restricao.inibidoAutomaticamente,
                        dataInibido: restricao.dataInibido
                    });
                });

                resultadoFinal.push(Object.values(agrupado));
            });

            return resultadoFinal;
        },
        async visualizarAnaliseTerritorio(territorio) {
            try {
                const { data } = await OperacaoMonitoramentoService.buscarDadosAnaliseTerritorio(
                    this.$route.params.id,
                    territorio.id
                );

                const diagnosticoTerritorio = this.agruparPorCamada(
                    data.territorio,
                    'AREA_ANALISADA'
                );

                const diagnosticoTerritorioProx = this.agruparPorCamada(
                    data.territorioProximidade,
                    'PROXIMIDADE_TERRITORIO_ANALISADO',
                    territorio.geometria
                );

                const diagnosticoCar = this.agruparPorTipo(
                    data.car,
                    'CAR_ANALISADO'
                );

                const diagnosticoCarProx = this.agruparPorTipo(
                    data.carProximidade,
                    'PROXIMIDADE_CAR_ANALISADO'
                );

                const diagnosticoPessoa = this.agruparPorTipo(
                    data.pessoaTerritorio,
                    'PESSOA'
                );

                const grupos = [];

                if (diagnosticoTerritorio.length > 0) {
                    grupos.push({
                        nome: territorio.nome,
                        titulo: this.$t('mensagens.operacao.monitoramento.areaAnalisada'),
                        codigo: 'AREA_ANALISADA',
                        diagnostico: diagnosticoTerritorio
                    });
                }

                if (diagnosticoTerritorioProx.length > 0) {
                    grupos.push({
                        nome: territorio.nome,
                        titulo: this.$t('mensagens.operacao.monitoramento.PROXIMIDADE_TERRITORIO_ANALISADO'),
                        codigo: 'PROXIMIDADE_TERRITORIO_ANALISADO',
                        proximidadeBuffer: true,
                        diagnostico: diagnosticoTerritorioProx
                    });
                }

                const maxLength = Math.max(diagnosticoCar.length, diagnosticoCarProx.length);

                for (let i = 0; i < maxLength; i++) {
                    if (i < diagnosticoCar.length && diagnosticoCar[i].length > 0) {
                        const primeiroItem = diagnosticoCar[i][0];
                        const primeiroResultado = primeiroItem?.resultados?.[0];
                        const carCode = primeiroResultado?.properties?.car;
                        const informacoesGerais = primeiroResultado?.properties?.informacoesGerais;

                        grupos.push({
                            titulo: this.$t('mensagens.operacao.monitoramento.carAnalisado'),
                            codigo: 'CAR_ANALISADO',
                            diagnostico: diagnosticoCar[i],
                            nome: carCode,
                            informacoes_gerais: informacoesGerais
                        });
                    }

                    if (i < diagnosticoCarProx.length && diagnosticoCarProx[i].length > 0) {
                        const primeiroItem = diagnosticoCarProx[i][0];
                        const primeiroResultado = primeiroItem?.resultados?.[0];
                        const carCode = primeiroResultado?.properties?.car;

                        grupos.push({
                            nome: carCode,
                            titulo: this.$t('mensagens.operacao.monitoramento.PROXIMIDADE_CAR_ANALISADO'),
                            codigo: 'PROXIMIDADE_CAR_ANALISADO',
                            diagnostico: diagnosticoCarProx[i],
                            proximidadeBuffer: true
                        });
                    }
                }

                diagnosticoPessoa.forEach(diagnostico => {
                    const primeiroItem = diagnostico[0];
                    const primeiroResultado = primeiroItem?.resultados?.[0];
                    const pessoaDocumento = primeiroResultado?.properties?.cpf_cnpj;
                    const pessoaNome = primeiroItem?.nomePessoa;

                    if (diagnostico.length > 0) {
                        grupos.push({
                            titulo: this.$t('mensagens.operacao.monitoramento.pessoaAnalisada'),
                            codigo: 'PESSOA',
                            diagnostico: diagnostico,
                            nome: `${pessoaNome || this.$t('mensagens.laudos.naoInformado')} | ${this.formatarDocumento(pessoaDocumento)}`
                        });
                    }
                });

                this.$refs.modalResultadoDiagnosticoRef.abrirModal({
                    grupo: grupos,
                    territorioGeometria: territorio.geometria
                });

            } catch (err) {
            }
        },

        async visualizarAnalisePessoa(pessoa) {
            const { data } = await OperacaoMonitoramentoService.buscarDadosAnalisePessoa(
                this.$route.params.id,
                pessoa.id
            );

            const agrupadoPorCamada = {};
            data.restricoes.forEach(item => {
                if (!agrupadoPorCamada[item.codigoCamada]) {
                    agrupadoPorCamada[item.codigoCamada] = {
                        camada: {
                            codigo: item.codigoCamada,
                            nome: item.propriedades?.camada?.nome,
                            fonte: item.propriedades?.camada?.fonte || {}
                        },
                        resultados: [],
                        nivelAlerta: item.nivelAlerta || 'BAIXO',
                        codigo: 'PESSOA_ANALISADA'
                    };
                }

                agrupadoPorCamada[item.codigoCamada].resultados.push({
                    id: item.codigoRestricao,
                    type: 'Feature',
                    propriedade: null,
                    properties: item.propriedades,
                    geometry: item.geometria,
                    inibido: item.inibido,
                    inibidoAutomaticamente: item.inibidoAutomaticamente,
                    dataInibido: item.dataInibido
                });
            });

            const diagnostico = Object.values(agrupadoPorCamada);

            this.$refs.modalResultadoDiagnosticoRef.abrirModal({
                grupo: [
                        {
                            territorioProximidade: false,
                            titulo: this.$t('mensagens.operacao.monitoramento.pessoaAnalisada'),
                            diagnostico: diagnostico,
                            codigo: 'PESSOA_ANALISADA',
                            nome: `${data.nome || this.$t('mensagens.laudos.naoInformado')} | ${this.formatarDocumento(data.documento)}`
                        }
                    ],
                    territorios: this.territorios,
                    diagnosticoPessoa: true
            });
        },

        async downloadPrimeiraAnalise() {
            try {
                await OperacaoService.downloadPrimeiraAnalise(
                    this.$route.params.id
                );
                this.$notify.success({
                    message: this.$t(
                        'mensagens.operacao.notificacao.downloadRealizado'
                    )
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.downloadAnaliseErro'
                    )
                });
            }
        },

        formatarValorTotalOperacao(valor) {
            if (valor) {
                return `R$ ${formatters.formatNumber(valor, 2)}`;
            }
            return 'R$ 0,00';
        },

        formatarDocumento(valor) {
            if (valor) {
                return formatters.numeralStringFormatToDocumento(valor);
            }
            return '#';
        }
    }
};
</script>

<style lang="scss">
#monitoramento-operacao {
    .monitoramento-operacao__header {
        margin: 0;
        align-items: center;
        padding: 20px;
        height: 100px;
        width: 100%;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .monitoramento-operacao__header__title {
            padding: 0;
            color: var(--primary-font-color);
            font-weight: map_get($font-weight, medium);
            font-size: map-get($font-size, x-large);
        }
    }

    .monitoramento-operacao__dados-gerais {
        margin-bottom: 20px;

        .monitoramento-operacao__dados-gerais__body {
            background-color: var(--white);
            min-height: 230px;
            width: 100%;
            padding: 24px;
            border-radius: $default-border-radius;
            box-shadow: 0 1px 5px 0 var(--block-shadow);

            .monitoramento-operacao__dados-gerais__body__title {
                font-size: 14px;
                color: var(--primary);
                margin-bottom: 5px;
            }

            .monitoramento-operacao__dados-gerais__body__value {
                font-size: 14px;
                color: var(--secondary-font-color);
            }
        }

        .operacao__card__elegibilidade-bonus-car {
            height: 55px;
            background-color: var(--milho-color);
            border-radius: $default-border-radius;
            justify-items: center;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: 600;
            margin: 15px 0;

            .operacao__card__elegibilidade-bonus-car--icone {
                font-size: 30px;
                display: flex;
                justify-content: center;
                width: 60px;
                height: 100%;
                border-radius: 4px 0 0 4px;

                .mdi {
                    z-index: 1;
                }

                .operacao__card__elegibilidade-bonus-car--icone--background {
                    background-color: var(--white);
                    z-index: 0;
                    height: 15px;
                    width: 15px;
                    position: absolute;
                }
            }
        }
    }

    .monitoramento-operacao__atividades {
        margin-bottom: 20px;
    }

    .monitoramento-operacao__restricoes {
        background-color: #f883421a;
        border-radius: $default-border-radius;
        height: 55px;
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .monitoramento-operacao__restricoes__icone {
            height: 100%;
            width: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px 0 0 4px;
            background-color: var(--warning);
            margin-right: 20px;

            .monitoramento-operacao__restricoes__icone__icone {
                font-size: 24px;
                color: var(--white);
            }
        }

        .monitoramento-operacao__restricoes__texto {
            line-height: 16px;
            font-weight: 600;
            font-size: 14px;
        }
    }

    .monitoramento-operacao__listagem-territorios {
        margin-bottom: 20px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lista-scroll {
        max-height: 300px;
        overflow-y: auto;
        flex-direction: column;
        padding: 5px 10px;

        /* width */
        &::-webkit-scrollbar {
            width: 10px;
            height: 10px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: var(--white);
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: var(--text-disabled);
            border-radius: 10px;
            border: 3px solid var(--white);
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            background: #b5b5b5;
        }
    }

    .monitoramento-operacao__listagem-pessoas {
        margin-bottom: 20px;
    }

    .titulo_padrao {
        font-weight: 600;
        font-size: 16px;
        width: 100%;
        margin-bottom: 10px;
    }

    .voltar {
        cursor: pointer;
        margin-right: 10px;
    }

    .tabela {
        border-radius: 5px;
        height: 400px;
        padding: 0;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .el-table {
            border-radius: 5px;
            height: calc(100% - 54px);
            width: 100%;
        }

        .el-table th {
            color: var(--primary);
            font-weight: normal;
            font-size: 13px;
        }

        .el-table__row.expanded:hover,
        .el-table--enable-row-hover
            .el-table__body
            tr:hover
            > td.el-table__cell,
        .el-table__row.expanded,
        td.el-table__cell.el-table__expanded-cell {
            background-color: var(--background-rgba) !important;
        }

        .expanded
            td.el-table_1_column_1.undefined.el-table__expand-column.el-table__cell,
        .el-table__row.expanded,
        td.el-table__cell.el-table__expanded-cell {
            border-left: 2px solid var(--secondary) !important;
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }

        .box-expande-listagem {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            margin-top: 15px;
            margin-bottom: 15px;
            padding: 0 18px;

            .box-expande-listagem-box {
                width: 33%;

                .box-expande-listagem-box-texto {
                    font-weight: 600;
                    color: var(--primary);
                }

                .box-expande-listagem-box-value {
                    padding: 0;
                    max-height: 75px;
                    overflow-y: auto;
                    font-weight: 400;
                    color: var(--primary);
                }
            }
        }
    }

    .remove-estilos {
        all: unset;
        caret-color: transparent;
    }

    .mapaMonitoramentoOperacao {
        background-color: #7777;
        height: 100%;
        width: 100%;
        border-radius: 5px;
    }

    #mapaMonitoramentoOperacao {
        border-radius: 5px;
    }

    .lista-scroll {
        max-height: 30px;
        overflow: auto;
    }

    .mudando-cursor {
        cursor: pointer;
    }

    .button-link {
        color: #1e90ff;
        text-decoration: underline;
    }
}
</style>
